/* eslint-disable */
import React, { useEffect } from "react";
import { getLandlordTenantInvitations } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const LandlordTenantInvitations = ({ getLandlordTenantInvitations, landlordTenantInvitations, period }) => {
  // Initial load
  useEffect(() => {
    getLandlordTenantInvitations({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getLandlordTenantInvitations(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getLandlordTenantInvitations(payload);
  };

  return (
    <DataTable
      {...tablePresets.landlordTenantInvitations}
      data={landlordTenantInvitations}
      fetchData={getLandlordTenantInvitations}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  landlordTenantInvitations: state.appProperties.landlordTenantInvitations,
});

const mapDispatchToProps = (dispatch) => ({
  getLandlordTenantInvitations: (payload) => dispatch(getLandlordTenantInvitations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandlordTenantInvitations);
